var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5376 23.8445L18.06 81.8252C17.4553 82.8722 17.1368 84.06 17.1367 85.2691C17.1366 86.4783 17.4548 87.6661 18.0593 88.7133C18.6639 89.7604 19.5334 90.63 20.5806 91.2345C21.6277 91.8391 22.8156 92.1573 24.0247 92.1572H90.9745C92.1836 92.1573 93.3715 91.8391 94.4186 91.2345C95.4658 90.63 96.3353 89.7604 96.9398 88.7133C97.5444 87.6661 97.8626 86.4783 97.8625 85.2691C97.8623 84.06 97.5439 82.8722 96.9392 81.8252L63.4652 23.8445C62.8608 22.7976 61.9914 21.9283 60.9446 21.3239C59.8977 20.7196 58.7102 20.4014 57.5014 20.4014C56.2926 20.4014 55.1051 20.7196 54.0582 21.3239C53.0113 21.9283 52.142 22.7976 51.5376 23.8445Z",
    fill: "#CAA53D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9381 41.7271H57.0648C54.9148 41.7271 53.1719 43.47 53.1719 45.62V64.2275C53.1719 66.3775 54.9148 68.1204 57.0648 68.1204H57.9381C60.0881 68.1204 61.831 66.3775 61.831 64.2275V45.62C61.831 43.47 60.0881 41.7271 57.9381 41.7271Z",
    fill: "#FFF7ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5014 82.8784C59.8926 82.8784 61.831 80.94 61.831 78.5488C61.831 76.1577 59.8926 74.2192 57.5014 74.2192C55.1103 74.2192 53.1719 76.1577 53.1719 78.5488C53.1719 80.94 55.1103 82.8784 57.5014 82.8784Z",
    fill: "#FFF7ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningYellow);
export default __webpack_public_path__ + "static/media/warning-yellow.9335ad54865a130f62fc24cd757b8976.svg";
export { ForwardRef as ReactComponent };